import React from 'react';
import { Button } from 'wbm-inputs';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { SelectModeCountMenu } from '../selectModeCountMenu/selectModeCountMenu';
import { CardHeader } from '../formElements/headerText';
import { CartItem } from '../cartItem/cartItem';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { PurchaseProcess } from '../../constants/enums';

export type SelectModeProps = {
    isExpanded: boolean,
    setIsExpanded: Function,
    btnText: string,
    headerText: string,
    onLinkClick: () => void,
    linkText: string,
    cartItemProps: Array<any>,
    selectModeCountMenuProps: object,
    customizeUrl?: Function,
    baseUrl?: string,
    displayListPrice?: boolean,
    removeMultiSelect: (product: any) => void
}

export const SelectMode = (props: SelectModeProps) => {
    const warning = props.cartItemProps.some((cartItem) => cartItem.purchaseProcess === PurchaseProcess.NavInk ||
        (cartItem.availabilityInfo && cartItem.availabilityInfo.doPreventAddToCart == true))

    return (
        <div className='select-mode'>
            <Button className={'btn-link medium expand-btn select-mode-button'} onClick={() => props.setIsExpanded(!props.isExpanded)}>
                {props.isExpanded ? <RemoveCircleOutlineIcon /> : <AddCircleOutlineIcon />}
                {props.btnText}
            </Button>
            <div className='select-mode-body'>
                {props.isExpanded && <>
                    <CardHeader text={props.headerText} onLinkClick={props.onLinkClick} linkText={props.linkText} className='select-mode-card-header' />
                    {warning ?
                        <div className={"alert-card select-mode danger"}>
                            <InfoOutlinedIcon style={{ marginRight: '5px', height: '24px', width: '24px', alignSelf: "flex-start" }} />
                            <div className="message">
                                There are some items below that require your attention.
                            </div>
                        </div>
                        :
                        <></>
                    }
                    <div className='cart-item-list-wrapper'>{props.cartItemProps.map((cartItemVal, index) => <div className='cart-item-wrapper-select-mode' key={"multi-select-" + index}><CartItem {...cartItemVal} customizedUrl={props.customizeUrl ? props.customizeUrl(cartItemVal, props.baseUrl) : ""} displayListPrice={props.displayListPrice} removeMultiSelect={() => props.removeMultiSelect(cartItemVal)} hostUrl={props.baseUrl} /></div>)}</div>
                </>}
                <div className='select-mode-menu'>
                    <SelectModeCountMenu {...props.selectModeCountMenuProps} />
                </div>
            </div>
        </div>)
};